import { getEnv, IStateTreeNode, Instance, IAnyType } from 'mobx-state-tree';
import { EventArgs } from './events';
import { createQueue, EventQueue } from '../lib';
import * as Resources from '../api';

type Environment = typeof Resources & {
    queue: EventQueue<EventArgs>;
};

const environment: Partial<Environment> = {
    ...Resources,
    queue: createQueue(event => event[0]),
};

const askEnv = (node: IStateTreeNode): Environment => {
    return getEnv<Environment>(node);
};

const createModel = <T extends IAnyType>(
    type: T,
    snapshot?: unknown
): Instance<T> => {
    return type.create(snapshot, environment);
};

export { askEnv, createModel, environment };
export type { Environment };
